(() => {
  "use strict";

  const MAX_VISIBLE_HEIGHT = 200;

  const onReady = (fn) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  };

  const setCssVar = (name, value) => {
    document.documentElement.style.setProperty(name, value);
  };

  const initHeaderHeight = () => {
    const header = document.querySelector("header.header");
    if (!header) return;

    const update = (height) => setCssVar("--header-height", `${height.toFixed(1)}px`);

    if ("ResizeObserver" in window) {
      const ro = new ResizeObserver((entries) => {
        if (!entries[0]) return;
        update(entries[0].contentRect.height);
      });
      ro.observe(header);
      return;
    }

    const fallbackUpdate = () => update(header.getBoundingClientRect().height);
    fallbackUpdate();
    window.addEventListener("resize", fallbackUpdate);
  };

  const setupExpandable = (selector) => {
    const wrappers = document.querySelectorAll(selector);

    wrappers.forEach((wrapper) => {
      const button = wrapper.nextElementSibling;
      if (!button) return;

      wrapper.classList.remove("expanded");
      wrapper.style.maxHeight = "";

      if (wrapper.scrollHeight <= MAX_VISIBLE_HEIGHT) {
        button.style.display = "none";
        wrapper.style.maxHeight = "none";
        return;
      }

      button.style.display = "inline-flex";
      wrapper.style.maxHeight = `${MAX_VISIBLE_HEIGHT}px`;
      button.textContent = "Read More";

      button.onclick = () => {
        const expanded = wrapper.classList.toggle("expanded");
        wrapper.style.maxHeight = expanded ? `${wrapper.scrollHeight}px` : `${MAX_VISIBLE_HEIGHT}px`;
        button.textContent = expanded ? "Read Less" : "Read More";
      };
    });
  };

  const initProductTabs = () => {
    const tabs = document.querySelectorAll(".product-tab");
    const contents = document.querySelectorAll(".tab-content");
    if (!tabs.length || !contents.length) {
      setupExpandable(".product-description-content");
      return;
    }

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const target = tab.dataset.tab;
        if (!target) return;

        tabs.forEach((t) => t.classList.remove("active"));
        tab.classList.add("active");

        contents.forEach((content) => {
          content.classList.toggle("active", content.id === target);
        });

        requestAnimationFrame(() => {
          setupExpandable(".product-description-content");
          setupExpandable(".product-spec-content");
        });
      });
    });

    setupExpandable(".product-description-content");
    setupExpandable(".product-spec-content");
  };

const initSearchBox = () => {
  const searchBox = document.querySelector(".search__box");
  const searchInput = document.querySelector('input[type="search"]');
  const searchForm = searchInput?.closest("form");

  if (!searchBox || !searchInput) return;

  const closeBox = () => {
    searchBox.classList.remove("is-open");
    searchBox.hidden = true;
    searchBox.style.removeProperty("display"); // removes old inline leftovers
  };

  const openBox = () => {
    searchBox.hidden = false;
    searchBox.classList.add("is-open");
  };

  const syncState = () => {
    if (searchInput.value.trim().length > 0) openBox();
    else closeBox();
  };

  // Initial
  closeBox();

  // Typing
  searchInput.addEventListener("input", syncState);

  // Important: browser clear (x) on type=search
  searchInput.addEventListener("search", syncState);

  // Form reset
  searchForm?.addEventListener("reset", () => {
    requestAnimationFrame(closeBox);
  });

  // Escape closes
  searchInput.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeBox();
  });

  // Click outside closes when empty
  document.addEventListener("click", (e) => {
    if (!searchForm?.contains(e.target) && !searchBox.contains(e.target) && searchInput.value.trim() === "") {
      closeBox();
    }
  });
};

  const initBackToTop = () => {
    const backToTop = document.getElementById("backToTop");
    if (!backToTop) return;

    let ticking = false;
    const update = () => {
      backToTop.classList.toggle("show", window.scrollY > 300);
      ticking = false;
    };

    window.addEventListener(
      "scroll",
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );

    backToTop.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });

    update();
  };

  const initCouponPopup = () => {
    const popup = document.getElementById("couponPopup");
    const closeBtn = popup ? popup.querySelector(".close-popup") : null;
    const couponCodeEl = document.getElementById("couponCode");
    const couponInfoEl = document.getElementById("couponInfo");
    const copyBtn = document.getElementById("copyCode");
    const toast = document.getElementById("copyToast");

    if (!popup || !couponCodeEl || !copyBtn || !toast) return;

    const showToast = () => {
      toast.classList.add("show");
      window.setTimeout(() => toast.classList.remove("show"), 1500);
    };

    const openPopup = (code, info) => {
      couponCodeEl.textContent = code || "";
      if (couponInfoEl) couponInfoEl.textContent = info || "";
      popup.classList.add("is-open");
    };

    const closePopup = () => popup.classList.remove("is-open");

    document.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-coupon-code]");
      if (!trigger) return;

      const code = trigger.getAttribute("data-coupon-code") || "";
      const info = trigger.getAttribute("data-coupon-info") || "";
      openPopup(code, info);
    });

    closeBtn?.addEventListener("click", closePopup);

    popup.addEventListener("click", (event) => {
      if (event.target === popup) closePopup();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closePopup();
    });

    copyBtn.addEventListener("click", async () => {
      const text = couponCodeEl.textContent?.trim();
      if (!text) return;

      try {
        await navigator.clipboard.writeText(text);
      } catch (_) {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.setAttribute("readonly", "");
        ta.style.position = "absolute";
        ta.style.left = "-9999px";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }

      showToast();
    });
  };

  onReady(() => {
    initHeaderHeight();
    initProductTabs();
    initSearchBox();
    initBackToTop();
    initCouponPopup();
  });
})();